import(/* webpackMode: "eager" */ "/app/app/UserProvider.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource-variable/space-grotesk/index.css");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")